import { useEffect, useState } from "react";

export function Image({
  src = "",
  alt,
  className,
}: {
  src?: string;
  alt: string;
  className?: string;
}) {
  const [error, setError] = useState(src === undefined || src === null);
  const handleError = () => {
    setError(true);
  };
  useEffect(() => {
    setError(src === undefined || src === null || src === "");
  }, [src]);
  if (error) {
    return (
      <div
        className={`flex items-center justify-center size-8 shrink-0 overflow-hidden rounded-full bg-primary/20 ${className}`}
      >
        <span className="text-sm font-medium text-neutral-600">
          {alt?.charAt(0).toUpperCase()}
        </span>
      </div>
    );
  }
  return (
    <img src={src} alt={alt} className={className} onError={handleError} />
  );
}
